import { useQuery } from '@tanstack/react-query'
import backend from '@api/backend'
import { mapHistoricalAlerts } from '@context/alert/context/alert.reducer'


export const useHistoricalAlertsByDate = (startDate: string | null, endDate: string | null, ackResults: number[]) => {
  return useQuery({
    queryKey: ['historical-alerts-date'],
    queryFn: () => getHistoricalAlertsByDate(startDate, endDate, ackResults),
    enabled: !!startDate || !!endDate,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 120, // 2 hours,
  })
}

export async function getHistoricalAlertsByDate(startDate: string | null, endDate: string | null, ackResult: number[]) {
  const response = await backend.get('/usage_alerts/history', {
    params: {
      startDate,
      endDate,
      ackResult
    },
    paramsSerializer: {
      indexes: null
    }
  })
  return mapHistoricalAlerts(response.data)
}